<template>
  <result-item-template>
    <template #label>
      <ys-text type="title5" class="result-title">
        <label-highlight
          :term="resultName"
          :highlight-parts="result.queryHighlight || []"
        />
      </ys-text>
    </template>
    <template #icon>
      <div class="leading-icon">
        <search-result-icon
          v-if="resultGlyphIcon"
          :result-type="result.about?.additionalType!"
          class="result-glyph"
        />
        <ys-icon
          v-else
          icon="ysSearch"
          size="medium"
          data-test="search-term-icon"
        />
      </div>
    </template>
    <template #metadata>
      <ys-text
        type="metadata1"
        class="result-metadata"
        data-test="autocomplete-result-description"
      >
        {{ resultDescription }}
      </ys-text>
    </template>
  </result-item-template>
</template>

<script lang="ts" setup>
import '@onxmaps/yellowstone-ui/ys-text'
import '@onxmaps/yellowstone-ui/ys-icon'
import '@onxmaps/yellowstone-ui/icons/ysSearch'
import ResultItemTemplate from '@/components/search/result-items/result-item-template.vue'
import SearchResultIcon from '@/components/search/search-result-icon.vue'
import LabelHighlight from '@/components/label-highlight.vue'
import { getGlyphIconFromSearchResultType } from '@/lib/glyph-markers'
import { computed } from 'vue'

import type { AutocompleteResult } from '@/lib/search/search-autocomplete'

interface AutocompleteResultsProps {
  result: AutocompleteResult
}

const { result } = defineProps<AutocompleteResultsProps>()

const resultName = computed(() => result.query)

const resultDescription = computed(() => {
  return (
    result.about?.disambiguatingDescription ||
    `Search map for "${result.query}"`
  )
})

const resultGlyphIcon = computed(() => {
  return result.about?.additionalType
    ? getGlyphIconFromSearchResultType(result.about.additionalType)
    : null
})
</script>

<style scoped>
.result-title {
  font-weight: normal;
  color: var(--ys-color-text-dim);
}

.result-metadata {
  color: var(--ys-color-text-secondary);
}
</style>
